import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-booking-details-customs',
  templateUrl: './booking-details-customs.component.html',
  styleUrls: ['./booking-details-customs.component.scss']
})
export class BookingDetailsCustomsComponent implements OnInit {

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  @Input()
  adminBookingDetails;

  @Input()
  adminBookingDetailsLoaded;

  @Input()
  bookingRef;

  public excessCustomsPayment = null;
  public receiptImg = '';
  public currencySymbol = '';
  public productType;

  constructor(
    private _router: Router
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.adminBookingDetailsLoaded !== 'undefined') {
      if (changes.adminBookingDetailsLoaded.currentValue) {
        this.excessCustomsPayment = this.adminBookingDetails.bookingJourneyDetails[0].excessBaggagePayment;
        this.currencySymbol = this.adminBookingDetails.bookingJourneyDetails[0].paymentDetails.currencySymbol;
        this.productType = this.adminBookingDetails.bookingJourneyDetails[0].addOnProductsOverview[0].addOnProductType
        if (this.excessCustomsPayment !== null) {
          this.receiptImg = this.excessCustomsPayment.receiptImageURL;
        }
      }
    }
  }

  redirectToSettings(event, type) {
    event.preventDefault();
    const redirectUrl = `my-account/settings-override?ref=${this.bookingRef}&type=${type}`;
    this._router.navigateByUrl(redirectUrl);
  }

}
